// «Mis entregas»: lo que el alumno ha enviado en las lecciones que piden archivo, con su
// estado y su nota (y el desglose si hubo rúbrica). Va al final de «Mi progreso» y también
// como sección suelta (`mis_entregas`) para cualquier página del proyecto. Si no ha enviado
// nada, no se muestra.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useProject } from '../../contexts/ProjectContext';
import { entregasService } from '../../services/api';
import { fmtFechaHoraBogota } from '../../utils/fecha';

const ESTADO = {
  pendiente: { t: 'En revisión', c: '#b7791f', f: '#fdf3e1' },
  aprobada: { t: 'Aprobada', c: '#1f8a5b', f: '#e3f5ec' },
  automatica: { t: 'Recibida', c: '#1f8a5b', f: '#e3f5ec' },
  devuelta: { t: 'Por corregir', c: '#c2412d', f: '#fbe9e5' },
};

const MisEntregas = ({ titulo, acento, vacio, mostrarVacio = false }) => {
  const { user } = useAuth();
  const { proyecto } = useProject();
  const [lista, setLista] = useState(null);
  useEffect(() => {
    if (!user) return;
    entregasService.mias(proyecto?.id).then(r => setLista(r.data?.entregas || [])).catch(() => setLista([]));
  }, [user, proyecto?.id]);

  if (!user || lista === null || (!lista.length && !mostrarVacio)) return null;
  return (
    <Caja $acento={acento || proyecto?.color_primario || '#0f766e'}>
      <h2>{titulo || 'Mis entregas'}</h2>
      {!lista.length ? <p className="vacio">{vacio || 'Aún no has enviado ninguna entrega.'}</p> : (
        <ul>
          {lista.map(e => {
            const est = ESTADO[e.estado] || ESTADO.pendiente;
            return (
              <li key={e.id}>
                <div className="que">
                  <Link to={`/mentor/${e.documento_id}`}>{e.leccion}</Link>
                  <span>{e.curso} · enviada el {fmtFechaHoraBogota(e.enviado_at, { hour: undefined, minute: undefined })}{e.tarde ? ' · fuera de plazo' : ''}</span>
                  {e.comentario_tutor && <p>{e.comentario_tutor}</p>}
                </div>
                <div className="como">
                  <b style={{ color: est.c, background: est.f }}>{est.t}</b>
                  {e.nota !== null && <span className="nota">{e.nota}{e.rubrica?.length ? ` / ${e.rubrica.reduce((t, r) => t + Number(r.max || 0), 0)}` : ''}</span>}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </Caja>
  );
};

export default MisEntregas;

const Caja = styled.section`
  max-width: 1100px; margin: 2.5rem auto 0; padding: 0 16px; color: #1f2a37;
  h2 { margin: 0 0 1rem; font-size: 1.35rem; }
  .vacio { color: #5b6675; }
  ul { list-style: none; margin: 0; padding: 0; border-top: 1px solid #e3e8ee; }
  li { display: flex; justify-content: space-between; gap: 1rem; padding: .9rem 0; border-bottom: 1px solid #e3e8ee; }
  .que { min-width: 0; }
  .que a { color: ${p => p.$acento}; font-weight: 700; text-decoration: none; }
  .que a:hover { text-decoration: underline; }
  .que span { display: block; color: #5b6675; font-size: .86rem; margin-top: .15rem; }
  .que p { margin: .4rem 0 0; padding-left: .7rem; border-left: 3px solid #e3e8ee; color: #5b6675; font-size: .9rem; white-space: pre-line; }
  .como { display: flex; flex-direction: column; align-items: flex-end; gap: .3rem; flex: none; }
  .como b { padding: .2rem .7rem; border-radius: 999px; font-size: .8rem; }
  .nota { font-size: 1.15rem; font-weight: 800; font-variant-numeric: tabular-nums; }
  @media (max-width: 600px) { li { flex-direction: column; } .como { flex-direction: row; align-items: center; } }
`;
